export default __webpack_public_path__ + "static/media/down-arrow-orange.ad740969.svg";